'use strict';

const CollectionView = require('./collection');

const TimeView = require('./time');

class TimesView extends CollectionView {
  initialize() {
    this.templateName = 'times';
    this.childView = TimeView;
    this.setModule('glive_booking_redesign');
  }

  attributes() {
    return { 'data-bhw': 'TimePicker' };
  }

  constructor() {
    super(...arguments);
    this.on('select', this.select, this);
  }

  select(time) {
    this.options.selection = time;
    setTimeout(() => this.render(), 0);
  }
}

module.exports = TimesView;
